<div class="row">
<div class="col-md-6">
  <div>
    <div class="card shadow-sm ">
      <div class="card-header with-border">
        Charterer
      </div>
      <div class="card-body">
        <div>
        <form #commentForm="ngForm"
          class="form-horizontal"
          (ngSubmit)="saveCharterer()">
          <div class="form-group row">
            <app-material-organisation-selector
              class="pg-component"
              [(ngModel)]="charterer"
              [organisationLanguage]="'en'"
              name="charterer"
              [organisations]="organisations"
              [placeholder]="'Select Charterer'"
              required>
            </app-material-organisation-selector>
          </div>
          <div class="btn-group pull-right mt-2" role="group" aria-label="Button group">
            <app-material-pg-button
              id="cancel"
              class="me-1"
              (clicked)="backToVoyage()"
              label="Back to voyage">
            </app-material-pg-button>
            <app-material-pg-button
              id="submit"
              (clicked)="saveCharterer()"
              [disabled]="!commentForm.form.valid"
              label="Save">
            </app-material-pg-button>
          </div>
        </form>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
